export default __webpack_public_path__ + "static/media/left_text_selected.96f966a7.svg";